import React, { useEffect } from 'react';
import { Link } from 'react-router';
import { FaWhatsapp } from 'react-icons/fa';
import Page from '../components/Page';
import { track } from '../analytics';
import { PHONE, WHATSAPP_HREF } from '../site';

const classes = [
  { id: 1, title: 'CSEC Math Form 4', day: 'Sundays', time: '10am – 12pm' },
  { id: 2, title: 'CSEC Math Form 5', day: 'Mondays', time: '5pm – 7pm' },
  { id: 3, title: 'CSEC Add Math Form 4', day: 'Tuesdays', time: '5pm – 7pm' },
  { id: 4, title: 'CSEC Add Math Form 5', day: 'Sundays', time: '10am – 12pm' },
  { id: 5, title: 'CAPE Pure Unit 1', day: 'Saturdays', time: '10am – 12pm' },
  { id: 6, title: 'CAPE Pure Unit 2', day: 'Tuesdays', time: '5pm – 7pm' },
];

const Classes = () => {
  useEffect(() => track('ViewContent', { custom: { content_name: 'Classes' } }), []);

  return (
    <Page title="Classes">
      <p className="text-lg font-semibold text-navy">Classes start in September.</p>
      <p className="mt-2 leading-relaxed text-gray-700">
        Online, with full syllabus coverage, past paper questions and
        personalised feedback.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {classes.map(({ id, title, day, time }) => (
          <div key={id} className="rounded-lg border border-navy/15 bg-white p-5 shadow-sm">
            <h2 className="font-bold text-navy">{title}</h2>
            <p className="mt-1 text-gray-700">
              {day}
              <span className="mx-2 text-navy/30">|</span>
              {time}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-10 flex flex-col gap-4 sm:flex-row">
        <Link
          to="/"
          className="rounded-lg bg-navy px-6 py-3 text-center font-medium text-white transition hover:bg-navy-light"
        >
          Sign up for a class
        </Link>
        <a
          href={WHATSAPP_HREF}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Contact')}
          className="flex items-center justify-center gap-2 rounded-lg border-2 border-navy px-6 py-3 font-medium text-navy transition hover:bg-navy hover:text-white"
        >
          <FaWhatsapp aria-hidden="true" /> WhatsApp {PHONE}
        </a>
      </div>
    </Page>
  );
};

export default Classes;
